import axios from 'axios'
import * as utils from './apiUtils'

export default {
  index(params) {
    return axios.get(utils.getApiUrl('/tenken_data_koukashita'), {
      params: params || {}
    })
  },
  search(params) {
    return axios.get(utils.getApiUrl('/tenken_data_koukashita/search'), {
      params: params || {}
    })
  },
  create(params) {
    return axios.post(utils.getApiUrl('/tenken_data_koukashita'), params)
  },
  show(id) {
    return axios.get(utils.getApiUrl(`/tenken_data_koukashita/${id}`))
  },
  update(id, params) {
    return axios.put(utils.getApiUrl(`/tenken_data_koukashita/${id}`), params)
  },
  delete(id) {
    return axios.delete(utils.getApiUrl(`/tenken_data_koukashita/${id}`))
  },
  bulkUpdatePhotos(id, params) {
    return axios.post(utils.getApiUrl(`/tenken_data_koukashita/${id}/bulk_update_photos`), params)
  },
  downloadSearchResultCSV(params) {
    return axios.get('/tenken_data_koukashita/download_search_result_csv.csv', {
      params: params,
      responseType: 'blob',
    })
  },
  getDailyReport(params) {
    return axios.post(utils.getApiUrl('/tenken_data_koukashita/get_daily_report'), params)
  },
  getMonthlyReport(params) {
    return axios.post(utils.getApiUrl('/tenken_data_koukashita/get_monthly_report'), params)
  },
}
